// extracted by mini-css-extract-plugin
export default {"warning":"style_warning__R6kzv","icon":"style_icon__yi84A","title":"style_title__yaS6B","subtitle":"style_subtitle__q5Du0"};